import React from 'react';
import { TemplateProps } from '../types';
import { DialogFooter } from './DialogFooter';

export const DialogActionsFooter = ({ children }: TemplateProps): JSX.Element => (
  <DialogFooter className='syte-dialog-actions'>{children}</DialogFooter>
);
